<template>
  <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="新增客户"
      @ok="handleSubmit"
      :width="1000"
  >
    <a-form class="custom-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="联系电话">
            <a-input
                v-decorator="['phone_number', {
              normalize: this.$lodash.trim,
            }]"
                autocomplete="off"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8" :xxl="6">
          <a-form-item label="用户姓名">
            <a-input
                v-decorator="['name', {
              normalize: this.$lodash.trim,
            }]"
                autocomplete="off"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-table
        :scroll="{ x: 'max-content' }"
        :columns="columns"
        :data-source="data"
        :pagination="false"
        row-key="id"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
    </a-table>
  </a-modal>
</template>

<script>
import {findTenantMiniProgramUserList} from "@/api/mini_program_user";
import {formatRangeBeginDate, formatRangeEndDate} from "@/utils/time";

export default {
  name: "AddProvideUser",
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    ids: {
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      query: {},
      data: [],
      form: this.$form.createForm(this, { name: 'user_search' }),
      selectedRowKeys: [],
      submitting: false,
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    columns() {
      return [
        {
          title: '用户名',
          dataIndex: 'name',
          width: 150
        },
        {
          title: '昵称',
          dataIndex: 'nick_name',
          width: 150
        },
        {
          title: '联系电话',
          width: 100,
          dataIndex: 'phone_number',
        },
      ]
    }
  },
  created() {
    this.fetchMiniUsers()
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    fetchMiniUsers() {
      this.data = []
      findTenantMiniProgramUserList(Object.assign({}, this.query)).then(res => {
        if (res.code === 0) {
          if (res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              if (!this.ids.includes(res.data[i].id)) {
                this.data.push(res.data[i])
              }
            }
          }
        }
      })
    },
    handleReset() {
      this.form.resetFields()
      this.query = {}
      this.fetchMiniUsers()
    },
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }
      let users = []
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        for (let i = 0; i < this.data.length; i++) {
          if (this.selectedRowKeys.includes(this.data[i].id)) {
            users.push(this.data[i])
          }
        }
      }
      this.isShow = false
      this.$emit('completed',users)
    },
    handleSearch(e){
      e.preventDefault()
      const fieldsValue = this.form.getFieldsValue()
      const values = {
        ...fieldsValue,
        created_at_begin: formatRangeBeginDate(fieldsValue.created_at),
        created_at_end: formatRangeEndDate(fieldsValue.created_at)
      }
      this.query = values
      this.fetchMiniUsers()
    }
  }
}
</script>

<style scoped>

</style>
